import { InventoryProjectionStatus } from "@redotech/crdb-enums/inventory/inventory-projection-status";
import { inventoryProjectionStatusLabels } from "@redotech/redo-fulfillment-operations-common/inventory-projection-status-labels";
import { fgInventoryProjectionFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import PackageIcon from "@redotech/redo-icons/package.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgInventoryProjectionFilterEntries.inventoryProjectionStatus;

export const InventoryProjectionStatusFilter: ArrayStringTableFilter<InventoryProjectionStatus> =
  {
    type: entry.type,
    Icon: PackageIcon,
    operators: [...entry.operators],
    data: {
      name: entry.name,
      type: entry.type,
      value: [],
      operator: ArrayStringFilterOperator.ANY_OF,
    },
    itemLabel: "status",
    itemLabelPlural: "statuses",
    values: [...entry.staticValues],
    display: (status) => inventoryProjectionStatusLabels[status],
    displayName: entry.displayName,
  };
